export const FETCH_TIMESLOTS = "FETCH_TIMESLOTS";
export const UPDATE_TIMESLOT_BLOCKED = "UPDATE_TIMESLOT_BLOCKED";
